exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.stars[data-v-4dc5ec28] {\n  display: flex;\n  gap: 10px;\n@media screen and (max-width: 600px) {\n    gap: 6px;\n}\n}\n.star[data-v-4dc5ec28] {\n  width: 28px;\n  min-width: 28px;\n  color: #ffffff;\n@media screen and (max-width: 600px) {\n    width: 20px;\n    min-width: 20px;\n}\n}\n.star.filled svg path[data-v-4dc5ec28] {\n  fill: #2f4286;\n}\n", ""]);

// exports
